import {
    FETCH_PROPERTY_OWNER_REQUEST,
    FETCH_PROPERTY_OWNER_SUCCESS,
    FETCH_PROPERTY_OWNER_FAILURE,
    CREATE_PROPERTY_OWNER_REQUEST,
    CREATE_PROPERTY_OWNER_SUCCESS,
    CREATE_PROPERTY_OWNER_FAILURE,
    UPDATE_PROPERTY_OWNER_REQUEST,
    UPDATE_PROPERTY_OWNER_SUCCESS,
    UPDATE_PROPERTY_OWNER_FAILURE,
  } from "../../actions/property-owner/types";
  
  const initialState = {
    createPropertyOwner: { loading: false, data: null, error: null },
    deletePropertyOwner: { loading: false, data: null, error: null },
    updatePropertyOwner: { loading: false, data: null, error: null },
    propertyOwnerList: { loading: false, data: null, error: null },
  };
  
  const PropertyOwnerList = (state = initialState, action) => {
    // console.log(action.type);
    switch (action.type) {
      //  Request
      case CREATE_PROPERTY_OWNER_REQUEST:
        return {
          ...state,
          createPropertyOwner: { ...initialState.createPropertyOwner, loading: true },
        };
      case UPDATE_PROPERTY_OWNER_REQUEST:
        return {
          ...state,
          updatePropertyOwner: { ...initialState.updatePropertyOwner, loading: true },
        };
      case FETCH_PROPERTY_OWNER_REQUEST: {
        return {
          ...state,
          propertyOwnerList: { ...initialState.propertyOwnerList, loading: true },
        };
      }
  
  // Success 
      case CREATE_PROPERTY_OWNER_SUCCESS: {
        // console.log(state.propertyOwnerList);
        return {
          ...state,
          createPropertyOwner: {
            ...state.createPropertyOwner,
            payload: action.payload,
            loading: false,
            error: null,
          },
          propertyOwnerList: addNewPropertyOwnerData(action.payload, {
            ...state.propertyOwnerList,
          }),
        };
      }
  
      case UPDATE_PROPERTY_OWNER_SUCCESS: {
        return {
          ...state,
          updatePropertyOwner: {
            ...state.updatePropertyOwner,
            loading: false,
            error: null,
            payload: action.payload,
          },
          propertyOwnerList: updatePropertyOwnerData(action.payload, {
            ...state.propertyOwnerList,
          }),
        };
      }
  
      case FETCH_PROPERTY_OWNER_SUCCESS: {
        // console.log(action.payload);
        return {
          ...state,
          propertyOwnerList: {
            ...initialState.propertyOwnerList,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
      }
  
      //failure
      case FETCH_PROPERTY_OWNER_FAILURE:
        return {
          ...state,
          propertyOwnerList: { data: null, loading: false, error: action.error },
        };
        case CREATE_PROPERTY_OWNER_FAILURE:
          return {
            ...state,
            createPropertyOwner: { data: null, loading: false, error: action.error }
          };
        case UPDATE_PROPERTY_OWNER_FAILURE:
          return {
            ...state,
            updatePropertyOwner: { data: null, loading: false, error: action.error }
          };
  
      default:
        return state;
    }
  };
  
  function updatePropertyOwnerData(dataToUpdate, state) {
    state.data.data = state.data.data.map((obj) => {
      if (obj._id !== dataToUpdate._id) return obj;
      return { ...dataToUpdate };
    });
  
    return state;
  }
  
  
  function addNewPropertyOwnerData(dataToUpdate, state) {
    state.data.data = [...state.data.data, dataToUpdate];
    state.data.total++;
    return state;
  }
  
  export default PropertyOwnerList;
  